import { render, staticRenderFns } from "./TokenSecurityChecks.vue?vue&type=template&id=40bfa4ee&scoped=true&"
import script from "./TokenSecurityChecks.vue?vue&type=script&lang=js&"
export * from "./TokenSecurityChecks.vue?vue&type=script&lang=js&"
import style0 from "./TokenSecurityChecks.vue?vue&type=style&index=0&id=40bfa4ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bfa4ee",
  null
  
)

export default component.exports